module.exports = __webpack_public_path__ + "static/img/18.a932481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/topPage/18.png
// module id = uldh
// module chunks = 0